// src/pages/Home.tsx
import React from "react";
import Header from "./header";
import Footer from "./footer";
import GradientBg from "./gradient";

const Home = () => {
  return (
    <>
      <Header />
      <section className="section-main">
        <div className="content-main-box">
          <div className="text-title">
            Welcome to SODEXS!
          </div>
          <div className="text-des">
            Experience a faster, safer, and smarter way to manage your money.
          </div>

          <button className="cmb-buton">
            <span>
              Coming soon...
            </span>
          </button>
        </div>

        <div className="bg-parent-contro">
          <GradientBg />
        </div>

      </section>
      <Footer />
    </>
  );
};

export default Home;